import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { authClient } from '@/lib/auth-client'

export const Route = createFileRoute('/_app/_auth')({
  component: AuthLayout,
})

function AuthLayout() {
  const { data: session, isPending } = authClient.useSession()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isPending && !session) {
      navigate({ to: '/login' })
    }
  }, [isPending, session])

  if (isPending) return null

  return <Outlet />
}
